import React from "react";
import "./Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
// import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import Redirect_btn from "../../common-components/common-btn/redirect-btn/Redirect_btn";

function Banner() {
  return (
    <section className="home_bannersec">
      <div className="container-fluid p-0">
        <div className="slider_sec">
          <Swiper
            navigation={true}
            loop={true}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination, Navigation]}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className="sliderdiv">
                <video
                  className="slideimg"
                  src={process.env.PUBLIC_URL + "/assets/video/banner_vdo.mp4"}
                  autoPlay
                  muted
                  loop
                  playsInline
                  alt="Banner-video"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="sliderdiv">
                <img
                  className="slideimg"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/home/banner/banner2.png"
                  }
                  alt="Banner 2"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="sliderdiv">
                <img
                  className="slideimg"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/home/banner/banner3.png"
                  }
                  alt="Banner 3"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="sliderdiv">
                <img
                  className="slideimg"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/home/banner/banner2.png"
                  }
                  alt="Banner 2"
                />
              </div>
            </SwiperSlide>
          </Swiper>

          <div className="overlay_content">
            <div className="container p-1">
              <h1 className="welcometitle title">Welcome to Shore Clinic</h1>
              <p className="subtitle">
                Your Trusted Marine Medical Centre in Pune
              </p>
              <Redirect_btn name="Our Services" link="/services" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
